import { render, staticRenderFns } from "./BenefitsWorkingWithUsNewBlock.vue?vue&type=template&id=5f21042e&scoped=true&"
import script from "./BenefitsWorkingWithUsNewBlock.vue?vue&type=script&lang=js&"
export * from "./BenefitsWorkingWithUsNewBlock.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsWorkingWithUsNewBlock.vue?vue&type=style&index=0&id=5f21042e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f21042e",
  null
  
)

export default component.exports